import type { Messages } from "@prop/i18n";
import type en from "../en/trade";

export default {
  nav: { accounts: "Аккаунты", terminal: "Терминал", programs: "Программы", faq: "Вопросы", settings: "Настройки", signIn: "Войти" },
  markets: { crypto: "Крипто", fx: "FX / CFD", futures: "Фьючерсы" },
  common: { replay: "REPLAY", noData: "Нет данных", loading: "Загрузка…", close: "Закрыть", more: "Ещё", less: "Свернуть", none: "—", back: "Назад" },
  status: { LIVE: "Онлайн", degraded: "Сбой данных", closed: "Рынок закрыт", connecting: "Подключение…", offline: "Нет связи — переподключаемся" },
  terminal: {
    title: "Терминал",
    account: "Аккаунт",
    instrument: "Инструмент",
    search: "Поиск инструмента",
    searchHint: "нажмите / для поиска",
    noAccount: "Чтобы торговать, сначала откройте аккаунт.",
    toAccounts: "К аккаунтам",
    layout: "Раскладка",
    layouts: { standard: "Стандарт", chart: "График", dom: "DOM / стакан" },
    book: "Стакан",
    tape: "Лента сделок",
    ladder: "DOM",
    step: "Шаг",
    price: "Цена",
    size: "Объём",
    time: "Время",
    bid: "Bid",
    ask: "Ask",
    spread: "Спред",
    mark: "Mark",
    last: "Last",
    hotkeys: "Клавиши",
    hk: { buy: "Купить по рынку", sell: "Продать по рынку", cancel: "Отменить все ордера", flatten: "Закрыть позиции", search: "Поиск", sheet: "Клавиши и жесты", close: "Закрыть панель" },
    ladderHint: "Клик по ячейке bid — покупка по этой цене, по ячейке ask — продажа; ваши ордера видны рядом с ценой.",
    phone: {
      amount: "Сумма, USD",
      markets: "Рынки",
      all: "Все",
      recent: "Недавние",
      favorites: "Избранное",
      star: "В избранное",
      unstar: "Убрать из избранного",
      stats: "Статистика рынка",
      account: "Счёт",
      closeAll: "Закрыть все",
      noResults: "Ничего не найдено. Попробуйте тикер: BTC, EUR, GOLD.",
    },
    cme: "Для данных CME сначала нужно подписать соглашение подписчика.",
    signCme: "Прочитать и подписать",
    groups: { crypto: "Крипто-перпетуалы", currency: "Валюты", metal: "Металлы", energy: "Энергоносители", index: "Индексы", stock: "Акции", futures: "Фьючерсы" },
    kinds: { perp: "Perp", fx: "FX", cfd: "CFD", future: "Фьючерс" },
    accountSize: "Размер {v}",
    accountEquity: "эквити {v}",
    allAccounts: "Все аккаунты",
    feed: {
      label: {
        live: "Онлайн",
        connecting: "Подключение…",
        offline: "Нет связи",
        waiting: "Ждём данные",
        syncing: "Синхронизация",
        stale: "Задержка",
        closed: "Рынок закрыт",
        cme: "Нужно соглашение",
        licence: "Нет лицензии на данные",
        noSource: "Нет данных",
        denied: "Нет доступа",
      },
      why: {
        live: "Цены и стакан приходят в реальном времени.",
        connecting: "Подключаемся к потоку рыночных данных.",
        offline: "Соединение с потоком рыночных данных прервалось.",
        waiting: "Поток по этому рынку пока ничего не прислал.",
        syncing: "Стакан пересобирается с биржи — обычно несколько секунд.",
        stale: "Биржа несколько секунд не обновляла стакан, цены могут отставать.",
        closed: "Торговая сессия биржи закрыта; цены вернутся с открытием.",
        cme: "CME требует, чтобы каждый пользователь принял соглашение подписчика до показа данных по фьючерсам.",
        licence: "Для живых данных по фьючерсам CME нужна биржевая лицензия на данные — в этой среде её пока нет.",
        noSource: "Для этого рынка сейчас не подключён источник данных.",
        denied: "Этот аккаунт не может получать данные по этому рынку.",
      },
      todo: {
        offline: "Переподключение произойдёт само; ваши ордера остаются как есть.",
        stale: "Синхронизация восстановится сама; торгуйте осторожно, пока бейдж не покажет «Онлайн».",
        closed: "Выберите инструмент, рынок которого открыт.",
        cme: "Прочитайте и подпишите соглашение над графиком.",
        licence: "Пока торгуйте крипто или FX: переключите аккаунт слева вверху.",
        noSource: "Выберите другой инструмент или загляните позже.",
        denied: "Переключитесь на другой аккаунт.",
      },
      emptyBook: "Стакан пока пуст",
      emptyBookText: "Уровни появятся, как только биржа их пришлёт.",
      emptyTape: "Сделок пока нет",
      emptyTapeText: "Сделки появляются здесь по мере того, как проходят.",
      emptyChart: "Истории цен пока нет",
      emptyChartText: "Свечи начнутся с первых сделок.",
      opensAt: "Откроется {time}",
      proxy: "Референсная цена",
      proxyWhy: "Цена с референсного рынка (нет лицензии на данные CME).",
      proxyRef: { index: "Референс: базовый индекс.", spot: "Референс: спотовая цена.", front_month: "Референс: цена ближнего контракта." },
    },
    keys: {
      title: "Клавиатура и мышь",
      armed: "Торговые клавиши включены",
      trading: "Торговые клавиши",
      off: "Выключены: включите, чтобы торговать с клавиатуры.",
      anywhere: "Везде",
      chart: "На графике",
      armHint: "Торговые клавиши: B — купить, S — продать по рынку, X — отменить все, F — закрыть всё",
      gestures: {
        limit: "Shift+клик: лимитный ордер по цене",
        stop: "Alt+клик: стоп-ордер по цене",
        drag: "Перетащите линию ордера, чтобы сдвинуть его",
        bracket: "Потяните от позиции, чтобы поставить тейк-профит или стоп-лосс",
        zoom: "Колесо: масштаб",
        scale: "Потяните шкалу цен, чтобы растянуть; двойной клик — сброс",
      },
    },
    noMatch: "Ничего не найдено",
  },
  chart: {
    quick: "Быстрая сделка",
    quickHide: "Свернуть быструю сделку",
    tvLoading: "Загружаем график TradingView",
    tf: "Таймфрейм",
    layers: "Слои",
    heatmap: "Тепловая карта",
    profile: "Профиль объёма",
    bubbles: "Крупные сделки",
    vwap: "VWAP",
    ema: "EMA",
    bb: "Боллинджер",
    volume: "Объём",
    gamma: "Гамма-уровни",
    gammaNone: "Гамма опционов есть для BTC и ETH",
    gammaLoading: "Загружаем опционы…",
    gammaInfo: "Опционы Deribit · экспираций: {n} · {time}",
    callWall: "Call wall",
    putWall: "Put wall",
    flip: "Разворот гаммы",
    settings: "Настройки",
    emaFast: "EMA быстрая",
    emaSlow: "EMA медленная",
    bbPeriod: "Период Боллинджера",
    bbWidth: "Ширина Боллинджера, σ",
    reset: "Сбросить вид",
    more: "Ещё",
    buyMkt: "Купить",
    sellMkt: "Продать",
    qty: "Количество",
    long: "ЛОНГ",
    short: "ШОРТ",
    tp: "ТП",
    sl: "СЛ",
    lmt: "ЛМТ",
    stp: "СТП",
    plus: "Ордер по {price}",
    buyLimit: "Купить лимит {qty} по {price}",
    sellLimit: "Продать лимит {qty} по {price}",
    buyStop: "Купить стоп {qty} по {price}",
    sellStop: "Продать стоп {qty} по {price}",
    help: "Shift+клик — лимит · Alt+клик — стоп · тяните линию, чтобы двигать ордер · от позиции — ТП/СЛ · колесо — масштаб · шкалу цены можно растянуть, двойной клик — сброс",
    heatNote: "Тепловая карта и крупные сделки записываются, пока график открыт.",
    view: "Вид графика",
    views: { desk: "Наш график", deskShort: "Наш", tv: "TradingView" },
    tvNote: "Цены здесь — от TradingView и могут отличаться от цен, по которым исполняются ваши ордера.",
    tvBy: "График TradingView",
    tvHint: "Интервалы, индикаторы и рисование — в панели TradingView",
    older: "Загружаем более раннюю историю…",
    olderBusy: "История сейчас занята — повторим через пару секунд",
    look: {
      title: "Вид",
      theme: "Тема",
      themes: { obsidian: "Funded Lime", midnight: "Полночь", graphite: "Графит", classic: "Классика", aurora: "Аврора", mono: "Моно", paper: "Бумага" },
      candles: "Свечи",
      styles: { filled: "Заливка", hollow: "Полые", bars: "Бары", heikin: "Хейкен-Аши" },
      background: "Фон",
      bgModes: { solid: "Ровный", gradient: "Градиент", glow: "Свечение", dots: "Точки" },
      colors: { up: "Рост", down: "Падение", background: "Фон" },
      grid: "Сетка",
      watermark: "Тикер на фоне",
      reset: "Сбросить вид",
    },
  },
  pro: {
    openInterest: "Открытый интерес",
    funding: "Фандинг",
    fundingValue: "{rate} / {h} ч",
    mark: "Mark",
    change24h: "Изменение 24ч",
    high24h: "Макс. 24ч",
    low24h: "Мин. 24ч",
    volume24h: "Объём 24ч",
    spread: "Спред",
    total: "Всего",
    long: "Купить / Лонг",
    short: "Продать / Шорт",
    available: "Доступно для торговли",
    mid: "Середина",
    sizePct: "Размер, % от покупательной способности",
    tpsl: "Тейк-профит / стоп-лосс",
    submitLong: "Купить {qty} {base}",
    submitShort: "Продать {qty} {base}",
    orderValue: "Стоимость ордера",
    entry: "Ожид. вход",
    maxSize: "Макс. размер",
    riskAtStop: "Риск на стопе",
    account: "Счёт",
  },
  ticket: {
    title: "Ордер",
    costDetails: "Детали стоимости",
    buy: "Купить",
    sell: "Продать",
    type: "Тип",
    types: { market: "Рыночный", limit: "Лимит", stop: "Стоп", stop_limit: "Стоп-лимит" },
    qty: "Количество",
    limitPx: "Лимитная цена",
    stopPx: "Стоп-цена",
    tif: "Срок действия",
    reduceOnly: "Только уменьшение",
    postOnly: "Только мейкер",
    bracket: "Тейк-профит / стоп-лосс",
    tp: "Тейк-профит",
    sl: "Стоп-лосс",
    risk: "Риск при срабатывании стопа",
    riskOfBalance: "{amount} · {pct} баланса",
    sizeFromRisk: "Объём от риска, %",
    apply: "Применить",
    noStop: "Добавьте стоп-лосс, чтобы видеть риск до отправки.",
    submit: "{side} {qty} {symbol}",
    submitted: "Отправлено — ждём движок",
    rejected: "Отклонён: {code}",
    filled: "Исполнено {qty} по {px}",
    realized: "P&L {v}",
    side: "Сторона",
    max: "Макс",
    lots: "лот.",
    maxNow: "макс {qty} {base} при {lev}×",
    amountUsd: "Сумма, USD",
    unit: "Единица",
    position: "Позиция",
    tpslIn: "TP / SL в",
    modes: { price: "Цена" },
    slRequired: "Эта программа требует стоп-лосс в каждом ордере.",
    marginAt: "Маржа при {lev}×",
    tradingFee: "Торговая комиссия",
    leverageFee: "Комиссия за плечо",
    tradingFeeAt: "Торговая комиссия {rate}",
    leverageFeeAt: "Комиссия за плечо {rate}",
    totalCost: "Всего на открытие",
    freeMargin: "Свободная маржа",
    powerHint: "Свободная маржа × плечо {lev}×",
    liqEst: "Ликвидация, оценка",
    liqNote: "Цена ликвидации — оценка: цена, при которой equity падает до поддерживающей маржи ({rate} номинала), остальные позиции — как сейчас. От плеча она не зависит.",
    why: {
      inactive: "Счёт в статусе {status}",
      closed: "Рынок закрыт",
      noPrice: "Ждём цену",
      noLimit: "Укажите лимитную цену",
      noStop: "Укажите стоп-цену",
      noSize: "Укажите объём",
      belowMin: "Минимальный объём — {min} {base}",
      overMax: "Больше покупательной способности при {lev}×: не больше {qty} {base}",
      reduceMax: "Только сокращение: не больше {qty} {base}",
      tpSide: "Тейк-профит должен быть {dir} цены входа",
      slSide: "Стоп-лосс должен быть {dir} цены входа",
      above: "выше",
      below: "ниже",
    },
    results: "Результаты ордеров",
    sending: "Отправляем…",
    working: "Выставлен — ждёт своей цены",
    refused: "Отклонён: {why}",
    actionFailed: "Не выполнено",
    reasons: {
      INSUFFICIENT_MARGIN: "не хватает свободной маржи",
      REDUCE_ONLY: "«только уменьшение» открыло бы позицию",
      NO_LIQUIDITY: "в стакане нет ликвидности",
      FOK_NOT_FILLED: "не удалось исполнить целиком",
      POST_ONLY_WOULD_TAKE: "мейкерский ордер забрал бы ликвидность",
      IOC_REMAINDER: "остаток отменён (исполнить или отменить)",
      POSITION_LIMIT: "превышен лимит позиции программы",
      MAX_OPEN_POSITIONS: "слишком много открытых позиций",
      STOP_LOSS_REQUIRED: "программа требует стоп-лосс",
      INVALID_BRACKET: "тейк-профит или стоп-лосс не с той стороны цены",
      FLAT_BY_TIME: "позиции программы закрыты по времени — новые со следующей сессии",
      WEEKEND_CLOSED: "программа закрывает FX / CFD на выходные — новые позиции с воскресенья 17:00 Нью-Йорк",
      NEWS_WINDOW: "окно важных новостей — закрыть можно, открыть или добавить нельзя",
      INSTRUMENT_NOT_ALLOWED: "инструмент не входит в программу",
      ACCOUNT_HALTED: "торговля на аккаунте остановлена",
      ROLL_WINDOW: "идёт переход на следующий контракт",
      OCO: "сработала другая нога брекета",
      LEVERAGE_OUT_OF_RANGE: "плечо вне допустимого диапазона",
      LEVERAGE_INSUFFICIENT_MARGIN: "открытым позициям не хватит маржи при таком плече",
    },
    leverage: {
      title: "Плечо",
      unavailable: "Плечо здесь пока нельзя изменить",
      forInstrument: "для {symbol}",
      forAccount: "для всего аккаунта",
      less: "Меньше",
      more: "Больше",
      margin: "Маржа для объёма в тикете",
      noSize: "укажите объём",
      maxAt: "Макс. объём при {v}×",
      apply: "Поставить {v}×",
      pending: "Ставим {v}×…",
      applied: "Плечо {v}×",
      range: "Целое число от {min}× до {max}×",
      marginUsed: "Занятая маржа",
      liqSame: "Плечо меняет маржу, а не цену ликвидации.",
      needsMargin: "При {v}× открытым позициям нужно {need} маржи, а equity — {equity}.",
      refused: "Не изменено: {why}",
      noAnswer: "движок не ответил, плечо осталось прежним",
      cancel: "Отмена",
    },
  },
  blotter: {
    positions: "Позиции",
    orders: "Ордера",
    fills: "Исполнения",
    trades: "Сделки",
    instrument: "Инструмент",
    side: "Сторона",
    qty: "Кол-во",
    avgPx: "Ср. цена",
    markPx: "Цена",
    upnl: "Плавающий P&L",
    rpnl: "Фикс. P&L",
    type: "Тип",
    price: "Цена",
    status: "Статус",
    filled: "Исполнено",
    fee: "Комиссия",
    liquidity: "Ликвидность",
    time: "Время",
    entry: "Вход",
    exit: "Выход",
    pnl: "P&L",
    cancel: "Отменить",
    close: "Закрыть",
    flatten: "Закрыть всё",
    cancelAll: "Отменить все",
    empty: "Пока пусто",
    why: "Почему здесь",
    emptyTitle: { positions: "Открытых позиций нет", orders: "Активных ордеров нет", fills: "Исполнений пока нет", trades: "Закрытых сделок пока нет" },
    emptyText: {
      positions: "Позиция, открытая из тикета, с графика или из стакана, появится здесь с живым P&L.",
      orders: "Лимитные и стоп-ордера ждут здесь, пока не исполнятся или вы их не отмените.",
      fills: "Каждое исполнение — с рынком в тот момент (Почему здесь).",
      trades: "Сделка появится здесь, когда её позиция закроется.",
    },
    upnlHint: "До комиссий, по цене, по которой движок оценивает позицию (так же на графике)",
    leverageFee: "Комиссия за плечо",
    marginAt: "Маржа · {lev}×",
    leverageFeeHint: "Часть комиссии: плата за торговлю с плечом",
    snapshot: {
      title: "Рынок в момент исполнения",
      model: "Модель исполнения",
      models: { walk: "прошёл по стакану", queue: "дошла очередь", trade_through: "цену прошли сделки", quote: "по котировке", tiers: "синтетическая глубина" },
      latency: "Задержка",
      quoteAge: "Возраст котировки",
      policy: "Политика исполнения",
      book: "Стакан (верх)",
    },
    long: "Лонг",
    short: "Шорт",
    buy: "Покупка",
    sell: "Продажа",
  },
  risk: {
    title: "Риск",
    dll: "Остаток дневного лимита",
    ml: "Остаток макс. лимита",
    target: "Цель",
    days: "Торговые дни",
    floor: "порог {v}",
    limit: "лимит {v}",
    near: "Близко к лимиту: у правила «{rule}» осталось {left}.",
    paused: "Торговля на паузе до следующей сессии (дневной убыток).",
    breached: "Счёт остановлен: нарушено правило программы. Торговля закрыта; см. «Нарушения».",
    passed: "Фаза пройдена. Следующая фаза откроется автоматически.",
    practice: "Практический аккаунт — без правил программы.",
    microShare: "Доход от микроскальпинга",
    microHint: "лимит {max} % · сделки короче {sec} с",
    microHeld: "Цель ждёт: {share} % прибыли дали сделки короче {sec} с (лимит {max} %). Торгуйте дальше более длинными сделками — это не нарушение.",
    microPayout: "Выплата ждёт: {share} % прибыли с последней выплаты дали сделки короче {sec} с (лимит {max} %).",
    streak: "Прибыльных дней подряд",
    streakHint: "каждый ≥ {bar} · нужно для выплаты",
    status: "Аккаунт",
  },
  accounts: {
    emptyLead: "Выберите челлендж, торгуйте живой стакан, получайте выплаты.",
    step1: "Выберите челлендж",
    step1Note: "Размер, правила и цена — до оплаты.",
    step2: "Торгуйте живой стакан",
    step2Note: "Исполнение за 10–30 мс, у каждой сделки есть чек.",
    step3: "Получайте до 90 %",
    step3Note: "Выплаты по запросу после прохождения.",
    pnlTotal: "P&L с начала",
    count: "Счетов",
    active: "Активных",
    type: "Тип",
    size: "Размер счёта",
    startFree: "Купить челлендж",
    allPrograms: "Все программы и опции",
    title: "Аккаунты",
    lead: "Все ваши аккаунты: эквити и состояние каждого.",
    total: "Общее эквити по всем аккаунтам",
    sinceStart: "с начала",
    emptyTitle: "Пока ни одного аккаунта",
    newTitle: "Открыть аккаунт",
    empty: "Аккаунтов пока нет. Купите челлендж, чтобы начать.",
    practice: "Практика",
    challenge: "Челлендж",
    funded: "Funded",
    startChallenge: "Начать челлендж",
    balance: "Баланс",
    equity: "Equity",
    open: "Открыть",
    trade: "Торговать",
    program: "Программа",
    phase: "Фаза",
    created: "Начат",
    chooseMarket: "Рынок",
    chooseProgram: "Программа",
    start: "Начать",
  },
  dashboard: {
    monthNet: "Месяц",
    tradingDays: "Торговых дней",
    greenDays: "В плюсе",
    week: "Неделя",
    fills: "исполнений: {n}",
    daysN: "дней: {n}",
    overview: "Обзор",
    targetOf: "{progress} из {amount}",
    prevMonth: "Предыдущий месяц",
    nextMonth: "Следующий месяц",
    equityCurve: "Equity",
    rules: "Правила этой версии",
    version: "Версия {n} · {hash}",
    trades: "Сделки",
    calendar: "Календарь",
    breaches: "Нарушения",
    certificates: "Сертификаты",
    history: "История",
    stepper: "Фазы",
    current: "текущая",
    realized: "Фикс. P&L",
    fees: "Комиссии",
    openTerminal: "Открыть терминал",
    noTrades: "Закрытых сделок пока нет",
    certificate: "Сертификат",
    viewCertificate: "Открыть сертификат",
    noCertificates: "Сертификат появится, когда фаза будет пройдена.",
    dayNet: "{v} итог · {n} исп.",
    weekdays: "Пн,Вт,Ср,Чт,Пт,Сб,Вс",
  },
  certificate: {
    heading: "Сертификат о прохождении",
    body: "{name} прошёл фазу {phase} программы {program} (версия {version}).",
    balance: "Итоговый баланс {balance} на счёте {start}.",
    days: "Торговых дней: {n}.",
    issued: "Выдан {date} · ID {id}",
    demo: "Оценка на симулированном счёте. Сертификат не является предложением договора funded-трейдера.",
    print: "Печать",
  },
  cme: {
    title: "Данные CME — соглашение подписчика",
    frame: "Итоговый текст соглашения, согласованный с CME, появится здесь вместе с лицензией на рыночные данные.",
    intro: "Перед показом фьючерсных данных CME требует от каждого пользователя принять соглашение подписчика и указать, профессионал ли он.",
    q1: "Вы зарегистрированы у регулятора рынка ценных бумаг или фьючерсов?",
    q2: "Вы торгуете для кого-то, кроме себя?",
    q3: "Вы используете данные для бизнеса?",
    no: "Нет",
    yes: "Да",
    pro: "Профессиональные подписчики пока не поддерживаются.",
    name: "Полное имя как подпись",
    sign: "Подписать как непрофессионал",
    signed: "Подписано",
  },
  settings: {
    title: "Настройки",
    lead: "Как терминал ведёт себя для вас и какие соглашения нужны для рыночных данных.",
    trading: "Торговля",
    data: "Рыночные данные",
    defaultQty: "Количество по умолчанию",
    confirm: "Спрашивать перед отправкой ордера",
    confirmNote: "Ещё одно подтверждение перед тем, как ордер уйдёт из тикета.",
    hotkeysOn: "Торговые горячие клавиши",
    hotkeysNote: "Клавиши в терминале: покупка и продажа по рынку, отмена всех ордеров, закрытие позиций, поиск.",
    saved: "Сохранено",
    cmeNote: "Нужно, чтобы видеть данные фьючерсов. Займёт минуту.",
    account: "Аккаунт и вход",
    mfaOff: "Выключена — защитите вход и выплаты вторым фактором.",
    mfaSetUp: "Настроить",
    profile: "Профиль и пароль",
    edit: "Изменить",
    notifications: "Уведомления на e-mail",
    accountEmails: "Письма о моих счетах",
    accountEmailsNote: "Счёт готов, фаза пройдена, funded-счёт, нарушение. Чеки, выплаты, выводы и ответы поддержки приходят всегда.",
  },
  site: {
    heroTitle: "Своя проп-платформа: крипто, FX и фьючерсы",
    heroBody: "Один терминал, одни правила на программу, каждое исполнение объяснено. Симулированная торговля на реальных рыночных данных.",
    cta: "Смотреть программы",
    signIn: "Войти",
    markets: "Три рынка, одна платформа",
    marketText: {
      crypto: "Перпетуалы по живому стакану, реальный funding.",
      fx: "Мажоры и золото с реальными спредами и свопами.",
      futures: "Индексы, нефть и золото CME со стаканом DOM.",
    },
    honest: "Честные условия",
    honestBody: "Правила каждой версии фиксируются при покупке. Никаких внезапных изменений и скрытых фильтров: дневной убыток, максимальный убыток и граница дня прописаны явно.",
    programs: "Программы",
    compare: "Сравнение",
    size: "Счёт",
    price: "Цена",
    target: "Цель",
    dll: "Дневной убыток",
    ml: "Макс. убыток",
    days: "Мин. дней",
    split: "Доля",
    perMonth: "/ мес",
    launch: "стартовая цена",
    configurator: "Конфигуратор",
    family: "Программа",
    addons: "Дополнения",
    cmeL2: "Глубина CME (L2)",
    total: "Итого",
    rules: "Все правила",
    getStarted: "Начать",
    dayEnds: "Торговый день заканчивается {at}",
    rulesHash: "Хеш правил {hash}",
    programsLead: "Выберите рынок, программу и размер. Цена и правила версии видны до покупки.",
    faqLead: "Коротко об аккаунтах, исполнении и правилах.",
    consistency: "Стабильность",
    microScalp: "Микроскальпинг",
    microScalpNote: "сделки короче {sec} с",
    microScalpCell: "≤ {v} % прибыли",
    streak: "Перед выплатой",
    streakCell: "{n} дней подряд ≥ {v}",
    daysCell: "{n} дней ≥ {v}",
    bestDayCell: "лучший день ≤ {v} % прибыли",
    minProfitCell: "прибыль ≥ {v}",
    cycle: { weekly: "раз в 7 дней", bi_weekly: "раз в 14 дней", monthly: "раз в 30 дней" },
    fundedOnly: "funded-счёт",
    fairPlay: "Честная торговля",
    fairPlayCell: "Запрещены встречные и хеджирующие позиции между счетами — своими, чужими или в других компаниях, — а также копирование сделок и групповая торговля. Запрещены и несколько профилей одного человека, и арбитраж на задержках или ошибках цены: связанные профили не получают выплат. При любом злоупотреблении, схеме или мошеннической практике мы вправе отказать в выплате и закрыть причастные счета (см. «Запрещённые практики»).",
    scaling: "Масштабирование",
    scalingCell: "+{step} % каждые {months} мес., до {max}",
    segmentCell: "прибыль сверх капа выплаты остаётся на счёте",
    carryCell: "прибыль сверх капа выплаты можно вывести позже",
    resetCell: "после выплаты №{n} баланс к стартовому, дальше без капов",
    fundingLimit: "Лимит финансирования",
    fundingLimitCell: "{v} на трейдера по этой программе",
    daysBar: "день засчитывается при прибыли ≥ {v} %",
    tradeLoss: "Убыток одной сделки",
    tradeLossNote: "открытая сделка нарушает, как только её плавающий убыток превысит лимит",
    time: "Срок",
    windowCell: "{h} ч с первой сделки",
    daysN: "{n} дн.",
    maxDays: "Макс. торговых дней",
    inactivity: "Неактивность",
    inactivityCell: "{n} дн. без сделок — счёт закрывается",
    contracts: "Макс. контрактов",
    contractsCell: "{n} на инструмент",
    flat: "Позиции закрываются",
    flatNote: "время {city}; новые — со следующей сессии",
    weekend: "Выходные",
    weekendCell: "позиции закрываются в пт 16:55 Нью-Йорк",
    weekendNote: "новые — с вс 17:00 Нью-Йорк",
    news: "Важные новости",
    newsCell: "без новых сделок ±{n} мин",
    newsNote: "закрыть можно всегда",
    faq: "Частые вопросы",
  },
} satisfies Messages<typeof en>;
